// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { withStyles } from "tss-react/mui";
import cx from 'classnames';

export interface LabelProps {
  className?: string;
  classes?: Record<string, string>;
  text: React.ReactNode;
  withMarginTop?: boolean;
  big?: boolean;
}

const Label: React.FC<LabelProps> = (props: LabelProps) => {
  const { text, withMarginTop = true, big } = props;
  const classes = withStyles.getClasses(props);
  return (
    <div 
      className={cx(classes.root, { [classes.big]: big })} 
      style={withMarginTop ? {} : { marginTop: 0 }}
    >
      {text}
    </div>
  );
};

// Label.defaultProps = {
//   withMarginTop: true,
// };

const LabelStyled = withStyles(
  Label, 
  (theme, props) => ({
    "root": {
      color: theme.palette.colors.greyDark,
      fontSize: 13,
      margin: theme.spacing(3, 0, 0),
    },
    "big": {
      color: theme.palette.colors.black,
      fontSize: 18,
    }
  })
);

export default LabelStyled;